module.exports = __webpack_public_path__ + "static/fonts/AlibabaPuHuiTi-2-35-Thin.dfa78e84.ttf";